import React, { ReactElement } from 'react';
import { styles } from './FeatureCard.css';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { useTrackingContext } from '../Tracking';

export type FeatureCardProps = {
  image: ReactElement;
  title: string;
  href: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

export const FeatureCard = ({ image, title, href, onClick }: FeatureCardProps) => {
  const { tracker } = useTrackingContext();

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = event => {
    tracker.trackClick({ label: title, extraData: { moduleName: 'Feature card' } });
    onClick?.(event);
  };

  return (
    <a className={styles.featureCardContainer} href={href} onClick={handleClick}>
      <DomFont as="h4" className={styles.title}>
        {title}
      </DomFont>
      {image}
    </a>
  );
};
